import { THEMES } from "../variables/build"

export const getThemeStylesheet = (themeName) => {
  return THEMES[themeName] || THEMES["default"]
}
